export default "__VITE_ASSET__f380c0fc__"